"use strict";
/**
 *
 * PlumbContext
 *
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const plumb_1 = require("@domonda/plumb");
const usePlumb_1 = require("./usePlumb");
exports.PlumbContext = react_1.default.createContext(plumb_1.createPlumb(undefined));
function usePlumbContext() {
    const plumb = react_1.useContext(exports.PlumbContext);
    return plumb;
}
exports.usePlumbContext = usePlumbContext;
function PlumbProvider(props) {
    const { children, state, tag } = props, rest = __rest(props, ["children", "state", "tag"]);
    const plumb = usePlumb_1.usePlumb(state, tag, rest);
    return react_1.default.createElement(exports.PlumbContext.Provider, { value: plumb }, children);
}
exports.PlumbProvider = PlumbProvider;
